export const FLYOUT_GAP_PX = 4;
export const FLYOUT_BOTTOM_OFFSET_PX = 24;
export const FLYOUT_TOP_OFFSET_FALLBACK_PX = 152;
export const FLYOUT_MIN_WIDTH_PX = 240;
export const TOP_ACTION_BAR_SELECTOR = "[data-testid='top-action-bar']";
export const MAIN_CONTENT_SELECTOR = "main";

export type FlyoutPosition = {
  left: number;
  top: number;
  height: number;
};

function getMeasuredContentTop(): number | undefined {
  if (typeof document === "undefined") return undefined;

  const mainTop = document.querySelector(MAIN_CONTENT_SELECTOR)?.getBoundingClientRect().top;
  const topBarBottom = document.querySelector(TOP_ACTION_BAR_SELECTOR)?.getBoundingClientRect().bottom;

  if (mainTop != null && topBarBottom != null) {
    return Math.max(mainTop, topBarBottom);
  }

  return mainTop ?? topBarBottom;
}

export function computeFlyoutHeight(
  viewportHeight: number,
  top: number,
  bottomOffset = FLYOUT_BOTTOM_OFFSET_PX
): number {
  return Math.max(0, viewportHeight - top - bottomOffset);
}

export function computeFlyoutPosition(
  anchor: HTMLElement,
  viewportHeight = window.innerHeight,
  contentTop?: number | null
): FlyoutPosition {
  const rect = anchor.getBoundingClientRect();
  const measuredContentTop = contentTop ?? getMeasuredContentTop();
  const top = measuredContentTop != null ? measuredContentTop + FLYOUT_GAP_PX : FLYOUT_TOP_OFFSET_FALLBACK_PX;
  const height = computeFlyoutHeight(viewportHeight, top);

  return {
    left: rect.right + FLYOUT_GAP_PX,
    top,
    height
  };
}
